module.exports = __webpack_public_path__ + "media/images/promocode/promocode-icon-66963ceeec0c593e177dd0095cff260d.svg";